import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'

interface UploadDocumentsBannerProps {
  setActiveTabToDocuments: () => void
}

// this banner shows if requestedDocuments array is not empty
const UploadDocumentsBanner = ({ setActiveTabToDocuments }: UploadDocumentsBannerProps) => {
  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Warning}
        subtext={
          <FormattedMessage
            defaultMessage='Our team needs a few more things from you. <link>Upload documents</link>'
            id='sputnik.UploadDocumentsBanner__dezVS5'
            values={{
              link: (chunks) => (
                <TextLink
                  size={TextLinkSizes.SMALL}
                  onClick={setActiveTabToDocuments}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Upload documents'
            id='sputnik.UploadDocumentsBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default UploadDocumentsBanner
